import { useEffect, useMemo } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { buildTheme } from '../shared/theme'
import { useThemeMode } from '../shared/themeMode'
import { useShop } from '../shared/api/storefront'
import { CartProvider } from './cart/CartContext'
import { AuthProvider } from './account/AuthContext'
import StorefrontLayout from './StorefrontLayout'
import CatalogPage from './CatalogPage'
import CheckoutPage from './CheckoutPage'
import TrackPage from './TrackPage'
import LoginPage from './LoginPage'
import AccountPage from './AccountPage'
import LegalPage from './LegalPage'

/** Loads the shop, themes from its brand color, then renders the branded storefront + routes. */
export default function StorefrontShell() {
  const { data: shop } = useShop()
  const mode = useThemeMode()
  const theme = useMemo(() => buildTheme(shop?.brandColor, mode), [shop?.brandColor, mode])

  // The tab should read as the shop's own site (§10), not "DukaaNo".
  useEffect(() => {
    if (shop?.name) {
      document.title = shop.name
    }
  }, [shop?.name])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <CartProvider>
          <StorefrontLayout shop={shop}>
            <Routes>
              <Route path="/" element={<CatalogPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/track/:token" element={<TrackPage />} />
              <Route path="/login" element={<LoginPage />} />
              {/* Registration folded into the OTP login (D-083); keep the old path working. */}
              <Route path="/register" element={<Navigate to="/login" replace />} />
              <Route path="/account" element={<AccountPage view="orders" />} />
              <Route path="/account/profile" element={<AccountPage view="profile" />} />
              <Route path="/legal/:doc" element={<LegalPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </StorefrontLayout>
        </CartProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}
